var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardDriverDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Account/Drivers Info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 -1.77635684e-15 24.9998 -1.77635684e-15 24.9998 15.202 0 15.202"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 25 0 25 15.2275 0 15.2275"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Account/Drivers-Info",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4091,7.381 L7.5911,7.381 C6.9551,7.381 6.4401,7.896 6.4401,8.532 C6.4401,9.167 6.9551,9.682 7.5911,9.682 L17.4091,9.682 C18.0451,9.682 18.5601,9.167 18.5601,8.532 C18.5601,7.896 18.0451,7.381 17.4091,7.381",
    id: "Fill-1",
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4091,11.3422 L7.5911,11.3422 C6.9551,11.3422 6.4401,11.8572 6.4401,12.4932 C6.4401,13.1282 6.9551,13.6432 7.5911,13.6432 L17.4091,13.6432 C18.0451,13.6432 18.5601,13.1282 18.5601,12.4932 C18.5601,11.8572 18.0451,11.3422 17.4091,11.3422",
    id: "Fill-3",
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7435,15.304 L7.5915,15.304 C6.9545,15.304 6.4405,15.819 6.4405,16.455 C6.4405,17.09 6.9545,17.605 7.5915,17.605 L13.7435,17.605 C14.3795,17.605 14.8945,17.09 14.8945,16.455 C14.8945,15.819 14.3795,15.304 13.7435,15.304",
    id: "Fill-5",
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000200, 9.798000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.449,15.202 L4.551,15.202 C2.041,15.202 0,13.161 0,10.651 L0,1 C0,0.447 0.447,-1.77635684e-15 1,-1.77635684e-15 C1.553,-1.77635684e-15 2,0.447 2,1 L2,10.651 C2,12.057 3.144,13.202 4.551,13.202 L20.449,13.202 C21.855,13.202 23,12.057 23,10.651 L23,9.547 C23,8.994 23.447,8.547 24,8.547 C24.553,8.547 25,8.994 25,9.547 L25,10.651 C25,13.161 22.959,15.202 20.449,15.202",
    id: "Fill-7",
    fill: "#282827"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,15.2275 C23.447,15.2275 23,14.7805 23,14.2275 L23,4.5505 C23,3.1445 21.855,1.9995 20.449,1.9995 L4.551,1.9995 C3.145,1.9995 2,3.1445 2,4.5505 L2,5.6885 C2,6.2415 1.553,6.6885 1,6.6885 C0.447,6.6885 0,6.2415 0,5.6885 L0,4.5505 C0,2.0405 2.041,-0.0005 4.551,-0.0005 L20.449,-0.0005 C22.959,-0.0005 25,2.0405 25,4.5505 L25,14.2275 C25,14.7805 24.553,15.2275 24,15.2275",
    id: "Fill-10",
    fill: "#282827"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDriverDetails);
export default __webpack_public_path__ + "static/media/dashboard_driver_details.54eafae10077c281ec59d9c4b5f9827c.svg";
export { ForwardRef as ReactComponent };